// extracted by mini-css-extract-plugin
export var alignCenter = "_9e-d";
export var bannerShown = "_9e-6";
export var buttonContent = "_9e-0";
export var cardList = "_9e-1";
export var centerContent = "_9e-2";
export var chevron = "_9e-3";
export var closePanelButton = "_9e-k";
export var conversationContextContainer = "_9e-l";
export var conversationDetailContainer = "_9e-4";
export var detailWrapper = "_9e-7";
export var dropdownButton = "_9e-e";
export var dropdownTitle = "_9e-9";
export var fullHeight = "_9e-5";
export var hidden = "_9e-a";
export var icon = "_9e-b";
export var mergeSuggestionWrapper = "_9e-m";
export var panel = "_9e-i";
export var portalButtonsWrapper = "_9e-c";
export var right = "_9e-j";
export var tableSummaryContainer = "_9e-8";
export var tableSummaryHeader = "_9e-g";
export var threeDotsButton = "_9e-f";
export var wide = "_9e-h";